module.exports = __webpack_public_path__ + "static/media/1f.9a970448.jpg";